import { useEffect } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";

import { bodyClassesState } from "../state/atoms";

export const useGetBodyClasses = () => useRecoilValue(bodyClassesState);

export function useSetBodyClasses(bodyClasses) {
  const setBodyClassesState = useSetRecoilState(bodyClassesState);

  useEffect(() => {
    setBodyClassesState(bodyClasses);
  }, []);
}
